import { render, staticRenderFns } from "./timHome.vue?vue&type=template&id=3d828572&scoped=true&"
import script from "./timHome.vue?vue&type=script&lang=js&"
export * from "./timHome.vue?vue&type=script&lang=js&"
import style0 from "./timHome.vue?vue&type=style&index=0&id=3d828572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d828572",
  null
  
)

export default component.exports